export const TESTIMONIAL_TEST_KEY = 118 // 홈페이지 testimonial 영역 테스트
export const CHANNEL_TALK_TEST_KEY = 119 // B인 경우 채널톡 웨비나 메시지 노출 이벤트 발행
export const PRICING_CALCULATOR = 120 // 가격 계산기
export const AA_TEST_KEY = 129 // AA 테스트용 키 - 지속적으로 테스트 예정
export const ADD_DATA_ANALYTICS_DETAIL_PAGE = 146 // 데이터 분석 소개 페이지 및 더 알아보기 버튼 추가
